import type { ParentComponent } from 'solid-js';
import { Navigate } from '@solidjs/router';
import { useAuth } from '~/shared/api/auth-context';

export const RequireAuth: ParentComponent = (props) => {
  const { isAuthenticated } = useAuth();
  return (
    <>
      {isAuthenticated() ? (
        props.children
      ) : (
        <Navigate href="/login" />
      )}
    </>
  );
};

export const RequirePermission: (permission: string) => ParentComponent =
  (permission) => (props) => {
    const { isAuthenticated, hasPermission } = useAuth();
    if (!isAuthenticated()) return <Navigate href="/login" />;
    return <>{hasPermission(permission) ? props.children : <Navigate href="/" />}</>;
  };
